import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Activos from "../views/components/AsingActivos.vue";
import GestionBajas from "../views/GestionBajas.vue";
import Profile from "../views/Profile.vue";
import Signin from "../views/Signin.vue";
import NewUsers from "../views/components/NewUsers.vue";
import NewRegional from "../views/components/NewRegional.vue";
import NewActivos from "../views/components/NewActivos.vue";
import Personal from "../views/components/UsuariosRegistrados.vue";
import Historial from "../views/components/HistorialMantenimiento.vue";
import Gestion from "../views/components/ManagementActivos.vue";
import Transferencias from "../views/components/Transferencias.vue";
import Detalles from "../views/Items/ViewDetails.vue";
import RealizarBaja from "../views/Items/RealizarBaja.vue";
import Reportes from "../views/components/Reportes.vue";
import Monitoreo from "../views/components/Monitoreo.vue";
import GestionActivo from "../views/Items/GestionActivo.vue";
import ModuloPredictivo from "../views/components/ModuloPredictivo.vue";
import ConfiguracionDifusa from "../views/components/ConfiguracionDifusa.vue";
import SolicitudUsuario from "../views/components/TI/SolicitudUsuario.vue"
import GestionTickets from "../views/components/TI/GestionTickets.vue";
import AdminDashboard from "../views/components/AdminDashboard.vue";
import SolicitudAcceso  from "../views/components/SolicitudAcceso.vue";
import MisActivos from "../views/components/MisActivos.vue";
import CrearUsuarios from "../views/components/CrearUsuarios.vue";

const routes = [
  {
    path: "/",
    redirect: "/dashboard-default",
  },
  
  // --- RUTAS PÚBLICAS (No requieren sesión) ---
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/nuevos-usuarios",
    name: "Registro Publico", // NOMBRE CORREGIDO
    component: NewUsers,
  },

  // --- RUTAS PRIVADAS (Requieren sesión) ---
  {
    path: "/dashboard-default",
    name: "Inicio",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/gestion-activos", 
    name: "Gestion de Activos",
    component: Gestion,
    meta: { requiresAuth: true },
  },
  {
    path: "/asignar-activos", 
    name: "Asignar Activos",
    component: Activos,
    meta: { requiresAuth: true },
  },
  {
    path: "/gestion-bajas",
    name: "Gestión de Bajas",
    component: GestionBajas,
    meta: { requiresAuth: true }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/new-regional",
    name: "Crear Regionales",
    component: NewRegional,
    meta: { requiresAuth: true },
  },
  {
    path: "/nuevos-activos",
    name: "Crear Activos",
    component: NewActivos,
    meta: { requiresAuth: true },
  },
  {
    path: "/transferencias",
    name: "Transferencias de Activos",
    component: Transferencias,
    meta: { requiresAuth: true },
  },
  {
    path: "/personal",
    name: "Personal",
    component: Personal,
    meta: { requiresAuth: true },
  },
   {
    path: "/misactivos",
    name: "Mis Activos",
    component: MisActivos,
    meta: { requiresAuth: true },
  },
  {
    path: "/historial",
    name: "Historial de Mantenimiento",
    component: Historial,
    meta: { requiresAuth: true },
  },
  {
    path: "/activo/detalle/:id",
    name: "Detalle Activo",
    component: Detalles,
    meta: { requiresAuth: true },
  },
  {
    path: "/reportes",
    name: "Reportes y Estadísticas",
    component: Reportes,
    meta: { requiresAuth: true },
  },
  {
    path: "/monitoreo",
    name: "Monitoreo",
    component: Monitoreo,
    meta: { requiresAuth: true },
  },
  {
    path: "/realizar-baja",
    name: "Realizar Baja",
    component: RealizarBaja,
    meta: { requiresAuth: true },
  },
  {
    path: "/activo/gestion/:id",
    name: "Gestion Activo",
    component: GestionActivo,
    meta: { requiresAuth: true },
  },
  {
    path: "/modulo-predictivo",
    name: "Modulo Predictivo",
    component: ModuloPredictivo,
    meta: { requiresAuth: true },
  },
  {
    path: "/configuracion-difusa",
    name: "Logica Difusa",
    component: ConfiguracionDifusa,
    meta: { requiresAuth: true },
  },
  {
    path: "/solicitud-usuario",
    name: "Solicitud Usuario",
    component: SolicitudUsuario,
    meta: { requiresAuth: true },
  },
  {
    path: "/gestion-tickets",
    name: "Gestion Tickets",
    component: GestionTickets,
    meta: { requiresAuth: true },
  },
  {
    path: "/panel-administrativo",
    name: "Panel de Administracion",
    component: AdminDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/solicitud-acceso",
    name: "Solicitudes",
    component: SolicitudAcceso,
    meta: { requiresAuth: true },
  },
  {
    path: "/crear-usuarios",
    name: "Administracion Usuarios", // NOMBRE CORREGIDO
    component: CrearUsuarios,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// --- FUNCIÓN PARA VERIFICAR SI EL JWT EXPIRÓ ---
const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payloadBase64 = token.split('.')[1];
    const decodedJson = atob(payloadBase64); 
    const payload = JSON.parse(decodedJson);
    
    const isExpired = (payload.exp * 1000) < Date.now();
    return isExpired;
  } catch (error) {
    return true;
  }
};

// --- ÚNICO GUARDIÁN DE RUTAS ---
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("access");
  
  const isAuthenticated = token && !isTokenExpired(token);

  if (to.meta.requiresAuth && !isAuthenticated) {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("user");
    
    next("/signin");
  } 
  else if ((to.path === "/signin" || to.path === "/nuevos-usuarios") && isAuthenticated) {
    next("/dashboard-default");
  } 
  else {
    next();
  }
});

export default router;